// extracted by mini-css-extract-plugin
export default {"slider":"_1kBzyZs1rL5FKoZw0eSCLc","dots":"_1lLqC-GWgEl7dRqEEzPg_X","active":"_1VvpYEPATYT1XtFbzMzFVK","prevDot":"_2hSUqmDMVI6PyunMggs7n6","nextDot":"_1vo8ssaAqPBWYjnY_D9dod"};